import React, { useState } from 'react';
import {
  CompaniesDataService,
  MarketplaceCompaniesDataService,
} from '../../common/services';
import { CompanyResource } from '../../common/entities';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { Option } from 'react-bootstrap-typeahead/types/types';

interface Props {
  onSelect: (selected: Option[]) => void;
  onTouched: () => void;
  id: string;
}
/**
 * @description High level component for dealing with Briefed.in marketplace.
 * @param {Props} props
 * @return {JSX.Element}
 */
const CompanySelect = (props: Props): JSX.Element => {
  const [companies, setCompanies] = useState<CompanyResource[]>([]);
  const [busy, setBusy] = useState<boolean>(false);

  const getCompanies = async (query: string): Promise<void> => {
    setBusy(true);
    const result = await MarketplaceCompaniesDataService.getAllWithMeta({
      query: query ? query : '',
    });
    setCompanies(result.data);

    setBusy(false);
  };

  return (
    <React.Fragment>
      <AsyncTypeahead
        id={props.id}
        isLoading={busy}
        labelKey={(option) =>
          `${(option as CompanyResource).attributes.companyName} - ${
            (option as CompanyResource).attributes.website
          }`
        }
        onSearch={async (query: string) => {
          if (props.onTouched) {
            props.onTouched();
          }
          await getCompanies(query);
        }}
        onChange={props.onSelect}
        options={companies}
      />
    </React.Fragment>
  );
};

export default CompanySelect;
